import { GetServerSideProps } from 'next';

import { Articles } from '@/features/Articles';
import { api } from '@/features/Articles/api';
import {
  ArticleDataResponse,
  ArticlePageResponse,
  ArticleTopicsResponse,
} from '@/features/Articles/Articles.types';

import { withNavigationData } from '@/utils/withNavigationData';

type PageProps = {
  config: {
    articleData: ArticleDataResponse;
    pageData: ArticlePageResponse;
    topicData: ArticleTopicsResponse;
  };
};

const Page = ({ config }: PageProps) => (
  <Articles
    articleResponseData={config.articleData}
    pageData={config.pageData}
    topicData={config.topicData}
  />
);

export const getServerSideProps: GetServerSideProps = withNavigationData(async context => {
  const {
    query,
    locale,
  } = context;

  const page = query.page ?? '1';
  const parsedPage = Array.isArray(page) ?
    parseInt(page[0], 10) :
    parseInt(page, 10);

  const sorting = query.sorting ?? 'DESC';
  const parsedSorting = Array.isArray(sorting) ?
    sorting[0] :
    sorting;

  let config;

  try {
    const pageData = await api.getArticlePage({ locale });
    // i've added more params in articles, cause somehow here more params doesn't work
    const articleData = await api.getArticles({
      locale,
      'pagination[page]': parsedPage,
      'pagination[pageSize]': 8,
      'sort[createdAt]': parsedSorting,
    });

    const topicData = await api.getTopics({
      '[pagination][pageSize]': 100,
      'filters[articles][id][$notNull]': true,
      'filters[articles][publishedAt][$notNull]': true,
      locale,
      'sort[0]': 'order',
      'sort[1]': 'name',
    });

    config = {
      articleData: articleData.data,
      pageData: pageData.data,
      topicData: topicData.data,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      config,
    },
  };
});
export default Page;
